import React, { useMemo } from "react";
import styled from "styled-components";
import { WindowedGridLayout } from "@cld/react-window-layout";
import ExpandedItem from "../ExpandedItem/ExpandedItem";

const QUEUE_ITEM_HEIGHT = 217;
const QUEUE_ITEM_WIDTH = 188;

const StyledQueueItemsGrid = styled.div`
	width: 100%;
	height: 100%;
`;

const renderQueueItem = ({ queueIds, retryFailed, abort }, index) => {
	const id = queueIds[index];

	return id ? <ExpandedItem
		key={`q_ex_item_${id}`}
		id={id}
		paddingBottom="100%"
		gutter={17}
		retryFailed={retryFailed}
		abort={abort}
	/> : null;
};

const useQueueItemsSection = ({
	                              queueIds,
	                              retryFailed,
	                              abort,
                              }) => {
	return useMemo(
		() => ({
			itemHeight: QUEUE_ITEM_HEIGHT,
			totalItems: queueIds.length,
			renderItemComponent: renderQueueItem,
			isItemLoaded: true,
			items: queueIds,
			itemProps: {
				retryFailed,
				abort,
				queueIds,
			},
		}),
		[
			queueIds,
			retryFailed,
			abort,
		],
	);
};

const VirtualizedQueueItemsGrid = (props) => {
	const sections = [
		useQueueItemsSection(props),
	];

	return (
		<StyledQueueItemsGrid>
			<WindowedGridLayout
				itemWidth={QUEUE_ITEM_WIDTH}
				sections={sections}
			/>
		</StyledQueueItemsGrid>
	);
};

export default VirtualizedQueueItemsGrid;
